var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',[_c('div',[_vm._v("案例列表页面")])])
}
var staticRenderFns = []

export { render, staticRenderFns }